import * as React from 'react';

/**
 * The component return hidden student avatar icon
 * @return {React.ReactElement}
 * @constructor
 */
export default function HiddenAvatar(): React.ReactElement {
  return (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="35" cy="35" r="35" fill="#4B4B4B"/>
      <g clipPath="url(#hiddenAvatar)">
        <path d="M34.6953 28.665L40.4213 34.3909L40.4485 34.091C40.4485 31.0826 38.0037 28.6377 34.9952 28.6377L34.6953 28.665Z" fill="#29292B"/>
        <path d="M34.9957 25.0022C40.0127 25.0022 44.0845 29.074 44.0845 34.091C44.0845 35.2635 43.8482 36.3814 43.4392 37.4084L48.7562 42.7254C51.501 40.435 53.6642 37.4721 55.0003 34.091C51.8465 26.1111 44.0936 20.4578 34.9957 20.4578C32.4508 20.4578 30.0151 20.9122 27.752 21.7302L31.6783 25.6474C32.7053 25.2476 33.8232 25.0022 34.9957 25.0022Z" fill="#29292B"/>
        <path d="M16.8177 20.0489L20.9623 24.1934L21.7894 25.0205C18.79 27.3654 16.4179 30.4829 15 34.0911C18.1448 42.0711 25.9066 47.7244 34.9955 47.7244C37.8131 47.7244 40.5033 47.179 42.9664 46.1883L43.739 46.9609L49.0378 52.2688L51.3555 49.9602L19.1354 17.7312L16.8177 20.0489ZM26.8701 30.0921L29.6785 32.9005C29.5967 33.2914 29.5422 33.6821 29.5422 34.0911C29.5422 37.0996 31.987 39.5444 34.9955 39.5444C35.4045 39.5444 35.7953 39.4899 36.1771 39.4081L38.9855 42.2165C37.7767 42.8164 36.4316 43.18 34.9955 43.18C29.9784 43.18 25.9066 39.1082 25.9066 34.0911C25.9066 32.6551 26.2702 31.3099 26.8701 30.0921Z" fill="#29292B"/>
      </g>
      <defs>
        <clipPath id="hiddenAvatar">
          <rect width="40" height="40" fill="white" transform="translate(15 15)"/>
        </clipPath>
      </defs>
    </svg>

  );
}

